// eslint-disable-next-line import/no-anonymous-default-export
export default (url: string, size: string | number) => {
  if (typeof url !== 'string') {
    return url;
  }

  const sizeKeys = ['compact', 'large', 'grande', '1024'];
  const IMAGE_SIZE = {
    compact: [160, 160],
    large: [480, 480],
    grande: [600, 600],
    '1024': [1024, 1024],
  };

  if (typeof size === 'string') {
    size = size.toLowerCase();
    if (!sizeKeys.includes(size)) {
      return url;
    }
  } else if (typeof size === 'number') {
    if (!(size > 0)) {
      return url;
    }
    if (![1024].includes(size)) {
      return url;
    }
    size = `${size}`;
  } else {
    return url;
  }

  const pathArray = url.split('/');
  if (!/(s3\.amazonaws\.com)|(static\.pietrastudio\.com)/.test(pathArray[2])) {
    return url;
  }

  const lastIndex = pathArray.length - 1;
  if (!/^(jpg|png|jpeg)/i.test(pathArray[lastIndex].split('.')[1])) {
    return url;
  }

  const targetIndex = pathArray.findIndex((v) => /^public/.test(v));
  if (targetIndex === -1) {
    return url;
  }

  const newURL = new URL(url);
  newURL.hostname = 'd151315muslonm.cloudfront.net';
  newURL.searchParams.set('format', 'auto');
  newURL.searchParams.set('width', IMAGE_SIZE[size][0]);
  newURL.searchParams.set('height', IMAGE_SIZE[size][1]);
  return newURL.toString();
};
